import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CONTACT, TELEGRAM } from '../lib/contact';
import Seo from '../components/seo/Seo';
import { alternatePath, localeFromPath } from '../lib/i18n-routes';

/**
 * Bosh sahifada bu blok bo'lim sifatida chiqadi (h2), alohida /contact
 * sahifasida esa sahifaning yagona h1'i bo'lishi kerak. Shu sabab sarlavha
 * tegi props orqali beriladi — ko'rinish .tf-title .title klassi bilan bir xil.
 */
function Contact(props) {
    const Heading = props.as || 'h2';
    // Ichki sarlavhalar har doim bosh sarlavhadan bir daraja past
    const SubHeading = Heading === 'h1' ? 'h2' : 'h3';
    const [name, setName] = useState('');
    const [phone, setPhone] = useState('');
    const [message, setMessage] = useState('');
    const [sending, setSending] = useState(false);

    const { t } = useTranslation();
    const { pathname } = useLocation();
    const lang = localeFromPath(pathname);
    // Seo faqat alohida /contact sahifasida — bosh sahifada blok sifatida
    // chiqqanda HomeOne ning meta teglari ustidan yozib yubormasligi kerak.
    const standalone = Boolean(props.as);

    async function formHandler(e) {
        e.preventDefault();

        if (!name.trim() || !phone.trim()) {
            alert(t('form-required'));
            return;
        }

        const text = [
            '<b>Innobek — yangi ariza</b>',
            `Ism: ${name}`,
            `Telefon: ${phone}`,
            message ? `Xabar: ${message}` : null,
            `Sahifa: ${window.location.href}`,
        ]
            .filter(Boolean)
            .join('\n');

        setSending(true);

        try {
            const res = await fetch(
                `https://api.telegram.org/bot${TELEGRAM.token}/sendMessage`,
                {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        chat_id: TELEGRAM.chatId,
                        parse_mode: 'HTML',
                        text,
                    }),
                }
            );

            const data = await res.json();

            if (!data.ok) throw new Error(data.description || 'Telegram error');

            setName('');
            setPhone('');
            setMessage('');
            alert(t('form-success'));
        } catch (err) {
            console.error('Telegram sendMessage failed:', err);
            alert(t('form-error'));
        } finally {
            setSending(false);
        }
    }

    return (
        <div>
            {standalone ? (
                <Seo
                    title={t('contact-meta-title')}
                    description={t('contact-meta-desc')}
                    lang={lang}
                    path={lang === 'ru' ? '/ru/contact' : '/contact'}
                    altPath={alternatePath(pathname, lang)}
                />
            ) : null}
            <section id='aloqa' className="tf-section tf-contact">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-5 col-md-12">
                            <div className="content-about m-b50 mobie-40" data-aos="fade-right" data-aos-duration="800">
                                <div className="tf-title st2 m-b17">
                                    <Heading className="title">{t("connecting")}</Heading>
                                </div>
                                <p className="m-r-40">{t("connecting-desc")}</p>
                            </div>
                            <form className="form-contact" id="contactform" onSubmit={formHandler} data-aos="fade-right" data-aos-duration="800">
                                <fieldset>
                                    <input type="text" name="name" id="name" placeholder={t("name")} value={name} onChange={(e) => setName(e.target.value)} />
                                </fieldset>
                                <fieldset>
                                    <input type="tel" name="phone" id="phone" placeholder={t('phone')} value={phone} onChange={(e) => setPhone(e.target.value)} />
                                </fieldset>
                                <fieldset>
                                    <textarea placeholder={t("desc")} rows="5" tabIndex="4" name="message" value={message} onChange={(e) => setMessage(e.target.value)} className="message" id="message"></textarea>
                                </fieldset>
                                <button className="tf-button btn-effect" type="submit" disabled={sending}>
                                    <span className="effect">{sending ? t("sending") : t("send")}</span>
                                </button>
                            </form>
                        </div>
                        <div className="col-xl-7 col-md-12">
                            <div className="contact-details" data-aos="fade-left" data-aos-duration="800">
                                <div className="adress wrap-fx">
                                    <div className="location">
                                        <SubHeading>{t("address")}</SubHeading>
                                        <ul>
                                            <li>{t("office-address")}</li>
                                            <li>{t("work-hours-value")}</li>
                                        </ul>
                                    </div>
                                    <div className="mail">
                                        <SubHeading>{t("connection")}</SubHeading>
                                        <ul>
                                            <li><a href={CONTACT.phoneHref}>{CONTACT.phoneDisplay}</a></li>
                                            <li><a href={CONTACT.telegram} target="_blank" rel="noreferrer">{CONTACT.telegramLabel}</a></li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="flat-map">
                                    <iframe
                                        title='map'
                                        className="map-content"
                                        src={CONTACT.mapEmbed}
                                        width="1720"
                                        height="480"
                                        allowFullScreen=""
                                        loading="lazy"
                                        referrerPolicy="no-referrer-when-downgrade"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default Contact;
